import { FormInstance } from 'antd';

export function scrollPageToTop(): void {
	window.scrollTo({
		left: 0,
		top: 0,
		behavior: 'smooth'
	});
}

export function noop() {
	/* tslint:disable:no-empty */
}

export function scrollUploadFormIfError(form: FormInstance): void {
	const errorFields = form.getFieldsError();
	if (!errorFields || !errorFields.length) {
		return;
	}
	const hasError = errorFields.find((e) => e.errors && e.errors.length);
	if (!hasError || !hasError.name.length) {
		return;
	}
	const errorElm = document.getElementById(`uploader__${hasError.name.join('')}`);
	if (errorElm) {
		errorElm.scrollIntoView({
			behavior: 'smooth'
		});
	}
}

export function createLoadedImage(src: string): Promise<HTMLImageElement> {
	const image = new Image();
	image.src = src;
	return new Promise((rs) => {
		image.onload = () => {
			rs(image);
		};
	});
}
